import { createGroupsAppController } from '@wix/social-groups-app/dist/src/controllers/appController';
import { createAppController } from '@wix/social-group/dist/src/controllers/createAppController';

//https://pbo.wixpress.com/rpc-console-poc/wix-apps-webapp/app-jvm-137.42.wixprod.net/tpaDistributionService/getPublicApp?WyIzODM2YWUxOS04MDA0LTQyMmMtOTBhNC1hZWJlNzBhYWE0MjQiXQ==.e30=
export const GROUPS_WIDGET = 'a1f0f11f-2c2d-40c9-b42e-1ce811d15465';

export const GROUP_WIDGET = '49acda86-4503-46bf-8418-89616e71d45b';

const controllerByType = {
  [GROUPS_WIDGET]: createGroupsAppController,
  [GROUP_WIDGET]: createAppController,
};

export const createControllers = controllerConfigs => {
  return controllerConfigs.map(config => {
    const createController = controllerByType[config.type];
    if (createController) {
      return createController(config);
    }
  });
};
